import moment from "moment";
import {useState} from "react";
import {Card, Col, Form, Modal, Row} from "react-bootstrap";
import {useTranslation} from "react-i18next";
import Loading from "./Loading";
import {getIpPublic} from "../../utils/getIpPublic";
import Post from "../../api/Post";
import {getTokenExternal} from "../../utils/getTokenExternal";
import {ADD_APPOINTMENT, SAVE_LINK_PATIENT_AUTOAGENDAMIENTO} from "../../api/Routes";
import {useEffect} from "react";
import {getSource} from "../../utils/getSource";
import {FinalizarAutoAgendamiento} from "../../pages/autoagendamiento/FinalizarAutoAgendamiento";
import CardDinamic from "./CardDinamic";
import {mexReservadoOK} from "../../pages/autoagendamiento/AutoagendamientoV2";
import {IkeNowUrl} from "../../utils/ikeNowUrl";

export default function ConfirmarServicio({classTop='', data, setData, setCurrentScreen}){
    const { t } = useTranslation();
    const ikeNow = IkeNowUrl()
    const [items, setItems] = useState({
        showMex: false,
        showClb: false,
        checkedTerm: false,
        isReservating: false,
        hasCopayment: data.patient.account.hasCopayment || false,
        citaCostoMoneda: {
            costo: null,
            currency: ''
        }
    })

    //checamos si tiene copayment la cuenta
    useEffect(() => {
        const idEspecialidad = data.especialidadId;
        const especilidadDetail = data.patient.account?.specialtyDurationList?.filter(item => item.especialty?.id === idEspecialidad)
        let hasCopaymentEspeciality = false
        if (especilidadDetail.length) {
            hasCopaymentEspeciality = especilidadDetail[0].hasCopayment ?? false;
            const costo = especilidadDetail[0].amountPayment ?? null;
            const currency = especilidadDetail[0].currency?.code ?? null
            setItems(prev => ({
                ...prev,
                citaCostoMoneda: {
                    costo: costo,
                    currency: currency
                },
                hasCopayment: data.patient.account.hasCopayment && hasCopaymentEspeciality
            }))
        }
    }, [])

    const handleMakeAppointment = async (decision) => {
        if (decision) {
            setItems(prev => ({
                ...prev,
                isReservating: true
            }))
            let ipAddress = "";
            try {
                const respIP = await getIpPublic();
                ipAddress = respIP;
            } catch (error) {
                ipAddress = "";
            }

            //hacemos la cita
            try {
                const d = {
                    source: getSource(data.source),
                    appointmentStatus: items.hasCopayment ? 'PendientePago' : (data.patient.account && data.patient.account.automaticValidation) ? "Pagada" : "Pendiente",
                    patient: {
                        id: data.patient.id,
                        name: data.patient.name,
                        middleName: data.patient.middleName,
                        seccondSurname: data.patient.seccondSurname,
                        lastName: data.patient.lastName,
                        email: data.patient.email,
                        phoneNumber: data.patient.phoneNumber,
                        phoneNumber2: data.patient.phoneNumber2,
                        account: data.patient.account,
                        externalId: data.patient.externalId,
                    },
                    schedule: data.schedule,
                    especialty: {
                        id: data.especialidadId
                    },
                    linkPatient: data.patient.linkPatient,
                    legalWarnings: [{
                        acceptPatient: "approved",
                        ipAddress: ipAddress,
                        legalWarningType: "InformedConsent"
                    }],
                    esIkeNow: ikeNow
                }
                const responseToken = await getTokenExternal()
                const token = responseToken.data.access_token

                const response = await Post({url: ADD_APPOINTMENT, data: d, header: true, access_token: token})
                if (response.data.state) {
                    setItems(prev => ({
                        ...prev,
                        isReservating: false
                    }))
                    setCurrentScreen("mexReservadoOK")
                } else {
                    console.log('error')
                }
            } catch (error) {
                console.log('error catch')
            }
        } else {
            let d = {
                id: data.patient.linkPatient,
                active: false
            }
            try {
                await Post({url: SAVE_LINK_PATIENT_AUTOAGENDAMIENTO, data: d, header: false})
                setCurrentScreen("declinadoConsentimientoTLS")
            } catch (error) {
                console.log('error cach')
            }
        }
    }

    return (
        <Row className={classTop}>
            <Col xs="12" md={{span: 10, offset: 1}}>
                <Card className='mt-2 mb-5 shadow-sm'>
                    <Card.Body className="p-5">
                        <h5 className="colorLink mb-4 fw-700">Confirmar servicio</h5>
                        <div className="my-3">
                            <h6 className="colorLabel fw-700">Información del paciente</h6>
                            <div className="colorLabel mb-2">
                                <span className="fw-medium mr-2 fw-700">Paciente:</span>
                                <span>{`${data.patient.name} ${data.patient.middleName} ${data.patient.lastName} ${data.patient.seccondSurname}`}</span>
                            </div>
                            <div className="colorLabel mb-2">
                                <span className="fw-medium mr-2 fw-700">Teléfono:</span>
                                <span>{`${data.patient.phoneNumber}${data.patient.phoneNumber2 && `, ${data.patient.phoneNumber2}`}`}</span>
                            </div>
                            <div className="colorLabel mb-2">
                                <span className="fw-medium mr-2 fw-700">Correo electrónico:</span>
                                <span>{`${data.patient.email}`}</span>
                            </div>
                        </div>
                        <h5 className="colorLink mb-4 fw-700">Información del servicio</h5>
                        <div className="my-3">
                            <div className="colorLabel mb-2">
                                <span className="fw-medium mr-2 fw-700">Tipo de servicio:</span>
                                <span>Telemedicina (videollamada)</span>
                            </div>
                            <div className="colorLabel mb-2">
                                <span className="fw-medium mr-2 fw-700">Especialidad:</span>
                                <span>{data.especialidadName}</span>
                            </div>
                        </div>
                        <div className="mb-3">
                            <span className="colorLabel fw-medium mr-2 fw-700">Día y hora:</span>
                            <span
                                className="colorOrange date-time-help">{moment(data.hourInit, "DD-MM-YYYY HH:mm:ss").format('DD-MM-YYYY - HH:mm')} hrs</span>
                        </div>
                        <div className="mt-2 mb-4">
                            <button
                                className="mr-2"
                                onClick={() => setCurrentScreen("mexEspecialidad")}
                            >
                                Regresar
                            </button>
                            <button
                                type="submit"
                                onClick={() => setItems(prev => ({
                                    ...prev,
                                    showMex: true
                                }))}
                            >
                                Continuar
                            </button>
                        </div>

                        <div className="mb-3">
                            <h5 className="colorLink mb-2">Telemedicina</h5>

                            {ikeNow
                                ? <span className="colorLabel">
                                Al confirmar tu cita, recibirás un mensaje o correo electrónico con el enlace
                                    para acceder a tu consulta. Podrás ingresar hasta 5 minutos antes o después
                                    de la hora programada. Te recomendamos contar con una conexión a internet
                                    estable y un dispositivo con cámara y micrófono habilitados. </span>

                                : <span className="colorLabel">
                                Al dar clic en confirmar, llegará un mensaje a su celular y/o correo electrónico con un
                                link para acceder a su consulta. Recuerda tener una buena conexión de Internet para
                                conectarte a la hora de la Video llamada. Tienes 5 minutos antes y después de la hora
                                acordada. Para cancelar tu cita comunícate con nosotros al 55 2655 4390 </span>
                            }


                        </div>

                        <Modal show={items.showMex}
                               onHide={() => setItems(prev => ({...prev, showMex: false}))}
                               className="border-0"
                               size="lg"
                               backdrop={items.isReservating ? "static" : "nostatic"}
                               keyboard={!items.isReservating}
                        >
                            <Modal.Body className="p-2">
                                <div className="position-relative overflow-hidden">
                                    <h5 className="text-uppercase colorLabel">
                                        {ikeNow
                                            ? 'Aviso de privacidad simplificado video consulta.'
                                            : t('consentimiento_telesalud') }
                                    </h5>
                                    <hr/>
                                    <p className=" mb-0 colorLabel">
                                        {ikeNow
                                            ? 'Iké Grupo Empresarial S.A.P.I de C.V, filiales o subsidiarias ' +
                                            'recabará datos personales y/o datos personales sensibles para poder ' +
                                            'brindar el servicio de video consulta; los cuáles serán tratados conforme ' +
                                            'a nuestro aviso de privacidad el cual, podrá ser consultado en el siguiente ' +
                                            'link (direccionamiento a los legales de iké) y en cumplimiento con la ' +
                                            'Ley Federal de Protección de Datos Personales en Posesión de Particulares (LFPDPPP). '
                                            : t('consentimiento_mexico') }
                                        <a href="https://ikeasistencia.com/aviso-legal-y-de-privacidad/"
                                           target="blank">{t('siguiente_link')}</a>.
                                    </p>
                                    <p className="colorLabel mb-0">
                                        <strong>{t('fecha')} {moment().format('dddd DD MMMM YYYY HH:mm')} </strong>
                                    </p>
                                    <p className="colorLabel mb-0">
                                        {ikeNow
                                            ? 'Yo '
                                            : t('soy')}
                                        <strong>{`${data.patient.name} ${data.patient.middleName} ${data.patient.lastName} ${data.patient.seccondSurname}`}</strong>
                                        {ikeNow
                                            ? ' acepto expresamente que mis datos personales sensibles y/o datos ' +
                                            'personales sean recabados para la finalidad descrita. ' +
                                            '(El NO implica la imposibilidad de recibir el servicio requerido).'
                                            : t('representante_legal')}
                                    </p>
                                    <div className="mt-3">
                                        <Form.Group className="text-center">
                                            <input
                                                name="aceptarTerminos"
                                                type="checkbox"
                                                className="mr-2"
                                                value={items.checkedTerm}
                                                onChange={e => setItems(prev => ({
                                                    ...prev,
                                                    checkedTerm: e.target.checked
                                                }))}
                                            />
                                            <Form.Label className="fw-medium">Acepto Términos y Condiciones</Form.Label>
                                        </Form.Group>
                                    </div>
                                    {
                                        items.isReservating ? <div className="text-center"><Loading/></div> :
                                            <div className="d-flex justify-content-center">
                                                <div className="mr-2">
                                                    <button
                                                        className="declined"
                                                        onClick={() => handleMakeAppointment(false)}
                                                    >
                                                        Declinar
                                                    </button>
                                                </div>
                                                <div>
                                                    <button
                                                        onClick={() => handleMakeAppointment(true)}
                                                        disabled={!items.checkedTerm}
                                                    >
                                                        Aceptar
                                                    </button>
                                                </div>
                                            </div>
                                    }

                                </div>
                            </Modal.Body>
                        </Modal>
                    </Card.Body>
                </Card>
            </Col>
        </Row>
    )
}